import React, { useState, useEffect } from "react";
import { Link, Navigate, useNavigate } from "react-router-dom";
import Select from "react-select";
import { useFormik } from "formik";
import { useLocation } from "react-router-dom";
import Cookies from "js-cookie";
// import { ToastContainer, toast } from 'react-toastify';
import * as Yup from "yup";
// import { adminMainUrl } from "../../../Config";
import { toast, ToastContainer } from "react-toastify";
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import VisibilityIcon from '@mui/icons-material/Visibility';
import "react-toastify/dist/ReactToastify.css";
import { adminMainUrl } from "../../Config";
const ForgetChange = () => {
    const location = useLocation();
    // const notify = () => toast("Wow so easy!");
    const [mail, setMail] = useState(null);
    const navigate = useNavigate();
    const [showPassword, setShowPassword] = useState(true);
    const [roleId, setRoleId] = useState([]);
    // const location = useLocation();
    const validationSchema = Yup.object({
        new_password: Yup.string()
            .min(4, "Password must be at least 4 characters")
            .required("New Password is required"),
    });
    useEffect(() => {
        if (location.state?.email) {
            setMail(location.state.email);
        }
    }, [location.state]);
    const formik = useFormik({
        initialValues: {
            new_password: "",
        },
        validationSchema: validationSchema,
        onSubmit: async (values) => {
            try {
                const response = await fetch(
                    `${adminMainUrl}/api/forgot-pasword-update`,
                    {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json",
                            "auth-token": localStorage.getItem("auth-token"), // Add auth-token if required
                        },
                        body: JSON.stringify({
                            email: mail, // Pre-filled email
                            new_password: values.new_password, // New password entered by the user
                        }),
                    }
                );
                const data = await response.json();
                if (response.ok) {
                    toast.success(data?.msg);
                    navigate("/login"); // Redirect to login page
                } else {
                    toast.error(data?.msg);
                    const errorData = await response.json();
                    console.error("Error updating password:", errorData.message);
                }
            } catch (error) {
                console.error("Network error:", error);
            }
        },
    });

    return (
        <div className='account-page'><div className="main-wrapper">
            <div className="account-content">
                <div className="d-flex flex-wrap w-100 vh-100 overflow-hidden account-bg-01">
                    <div className="d-flex align-items-center justify-content-center flex-wrap vh-100 overflow-auto p-4 w-50 bg-backdrop">
                        <form onSubmit={formik.handleSubmit} className="flex-fill">
                            <div className="mx-auto mw-450">
                                <div className="text-center mb-4">
                                    <img src="/assets/img/logo.png" className="img-fluid" alt="Logo" />
                                </div>
                                <div className="mb-4">
                                    <h4 className="mb-2 fs-20">Sign In</h4>
                                    <p>Access the CRMS panel using your email and passcode.</p>
                                </div>

                                <div className="mb-3">
                                    <label className="col-form-label">Password</label>
                                    <div className="pass-group relative password-input">
                                        <input type={showPassword ? "password" : "text"}
                                            id="new_password"

                                            placeholder="Enter New Password"
                                            name="new_password"
                                            value={formik.values.new_password}
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                            required className="pass-input form-control" />
                                        {
                                            showPassword ?
                                                <VisibilityOffIcon className='cursor-pointer' style={{ fill: "rgb(82 80 80)" }} onClick={() => { setShowPassword(!showPassword) }} />
                                                :
                                                <VisibilityIcon className='cursor-pointer' style={{ fill: "rgb(82 80 80)" }} onClick={() => { setShowPassword(!showPassword) }} />
                                        }
                                    </div>
                                    {formik.touched.new_password && formik.errors.new_password ? (
                                        <div className="error">{formik.errors.new_password}</div>
                                    ) : null}
                                </div>
                                <div className="text-center">
                                    <p className="fw-medium text-gray">Copyright © 2024 - CRMS</p>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
        </div>
    )
}

export default ForgetChange